<template>
  <UiModal
    v-bind="MODAL_CONFIG"
    @before-open="modalBeforeOpen"
  >
    <template #default>
      <div :class="$style.description">
        Вы действительно хотите <b>{{ eventName }}</b>?
      </div>

      <UiDescriptionList
        :class="$style.info"
        :list="paramsList"
      />
    </template>

    <template #controls>
      <UiButton
        :fluid="true"
        :squared="true"
        :flat="true"
        theme="gray"
        @click="confirm"
      >
        Да
      </UiButton>
      <UiButton
        :fluid="true"
        :squared="true"
        :flat="true"
        theme="gray"
        @click="cancel"
      >
        Нет
      </UiButton>
    </template>
  </UiModal>
</template>

<script>
  import { MODALS } from '@/constants';
  import { formatTime } from '@/utils';
  import modalDynamicProperties from '@/mixins/modalDynamicProperties';
  import UiButton from '@/components/UiButton';
  import UiDescriptionList from '@/components/UiDescriptionList';
  import UiModal from '@/components/UiModal';

  const MODAL_CONFIG = {
    options: {
      name: MODALS.EVENT_CONFIRMATION,
      maxWidth: 400,
    },
  };
  const MODAL_PROPS_WHITELIST = {
    eventName: null,
    date: null,
    dayName: null,
    timeFrom: null,
    timeTo: null,
    confirmHandler: () => {},
    cancelHandler: () => {},
  };

  export default {
    name: 'ModalEventConfirmation',
    components: {
      UiButton,
      UiDescriptionList,
      UiModal,
    },
    mixins: [modalDynamicProperties],
    data: () => ({
      MODAL_CONFIG,
      ...MODAL_PROPS_WHITELIST,
    }),
    computed: {
      paramsList() {
        let dateDescription = `<b>${this.date}</b>`;
        if (this.dayName) {
          dateDescription += ` (${this.dayName})`;
        }
        const timeDescription = `<b>${formatTime(this.timeFrom)} &ndash; ${formatTime(this.timeTo)}</b>`;
        return [
          {
            icon: 'calendar',
            term: 'Дата:',
            description: dateDescription,
          },
          {
            icon: 'clock',
            term: 'Время:',
            description: timeDescription,
          },
        ];
      },
    },
    created() {
      this.setPropsWhitelist(MODAL_PROPS_WHITELIST);
    },
    methods: {
      confirm() {
        this.confirmHandler();
        this.$modal.hide(MODALS.EVENT_CONFIRMATION);
      },

      cancel() {
        this.cancelHandler();
        this.$modal.hide(MODALS.EVENT_CONFIRMATION);
      },
    },
  };
</script>

<style lang="scss" module>
  .description {
    margin-bottom: 16px;
  }

  .info {
    border-top: 1px solid lighten($colorBlue, 30%);
    padding-top: 16px;
  }
</style>
